module.exports = __webpack_public_path__ + "static/img/want-1.ef99040e.png";